















































import { computed, defineComponent, toRefs, PropType, ref, watch, nextTick } from '@vue/composition-api';
import {
  MaterialType,
  getAffiliateSortOptions,
  MaterialLibrarySortOptions,
  AffiliateVideoSearchType,
} from '@tt4b/ttam-enums';
import { i18n } from '@tt4b/ttam-i18n';
import { trackEvent } from './../../../../utils/index';

const name = 'ttam-library-shop-condition';

export default defineComponent({
  name,
  props: {
    keyword: {
      type: String,
      default: '',
    },
    keywordType: {
      type: Number as PropType<AffiliateVideoSearchType>,
      default: AffiliateVideoSearchType.Undefined,
    },
    sortType: {
      type: [String, Number, Boolean],
      default: undefined,
    },
    isAffiliate: {
      type: Boolean,
      default: false,
    },
    isVideoLibrary: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, { emit, refs }) {
    const { keyword, keywordType, sortType, isAffiliate, isVideoLibrary } = toRefs(props);
    const sortOptions = computed(() => {
      if (isAffiliate.value) {
        return getAffiliateSortOptions();
      }
      if (isVideoLibrary.value) {
        return MaterialLibrarySortOptions();
      }
      return [];
    });
    const curSortOption = computed(() => {
      const option = sortOptions.value?.find(_option => _option.value === sortType.value) ?? {};
      return option;
    });
    const curSortType = computed({
      get: () => curSortOption.value?.value,
      set: val => {
        trackEvent('creative_spark_ads_post_sort', { type: val });
        emit('sort-type-change', val);
      },
    });
    const isSupportSort = computed(() => isAffiliate.value || isVideoLibrary.value);
    watch(curSortType, val => {
      if (isAffiliate.value && curSortOption.value) {
        trackEvent('ad_start_with_product_video_sort', {
          sort_order: curSortOption.value.sortData?.sortOrder,
          sort_filed: curSortOption.value.sortData?.sortField,
        });
      }
    });

    const isSupportSearch = computed(() => isAffiliate.value || isVideoLibrary.value);
    const isSupportKeywordsTypeFilter = computed(() => isAffiliate.value);

    const searchOptions = computed(() => [
      {
        label: i18n.t('module_creative_post_search_by_post_id'),
        value: AffiliateVideoSearchType.ItemID,
      },
      {
        label: i18n.t('module_creative_post_search_by_post_caption'),
        value: AffiliateVideoSearchType.ItemName,
      },
      {
        label: i18n.t('module_creative_post_search_by_tt'),
        value: AffiliateVideoSearchType.IdentityName,
      },
    ]);
    const curKeyword = ref(keyword.value);
    const curKeywordType = ref(keywordType.value || searchOptions.value[0].value);
    watch(keywordType, val => {
      const option = searchOptions.value.find(item => item.value === val) || searchOptions.value[0];
      curKeywordType.value = option.value;
    });
    watch(keyword, val => {
      curKeyword.value = val;
    });
    function search() {
      emit('affiliate-search', {
        keyword: curKeyword.value,
        keywordType: curKeywordType.value,
      });
      const eventNameMap = {
        [AffiliateVideoSearchType.ItemID]: 'ad_start_with_product_search_post_id',
        [AffiliateVideoSearchType.ItemName]: 'ad_start_with_product_search_text',
        [AffiliateVideoSearchType.IdentityName]: 'ad_start_with_product_search_identity',
      };
      trackEvent(eventNameMap[curKeywordType.value]);
    }
    function onBlur() {
      if (curKeyword.value === keyword.value) {
        return;
      }
      search();
    }

    const numbers = new Set(
      Array(10)
        .fill('')
        .map(($, index) => String(index)),
    );
    // affiliate的搜索输入需要过滤成合法字符串
    function filterAffiliateInput(val: string) {
      let filted = val ?? '';
      if (isAffiliate.value) {
        if (curKeywordType.value === AffiliateVideoSearchType.ItemID) {
          filted = Array.from(val || '')
            .filter(character => numbers.has(character))
            .join('');
        }
        if (curKeywordType.value === AffiliateVideoSearchType.IdentityName) {
          filted = val.slice(0, 24);
        }
      }
      return filted;
    }
    function onInput(val: string) {
      const filted = filterAffiliateInput(val);
      curKeyword.value = filted;
      if (val !== filted) {
        nextTick(() => {
          if (refs.viInput) {
            const viInput = refs.viInput as any;
            viInput.currentValue = filted;
            viInput.$refs.input.value = filted;
          }
        });
      }
    }

    function onKeywordTypeChange() {
      // 如果搜索关键字为空，则直接返回。否则需要清空后重新触发搜索
      if (!curKeyword.value) {
        return;
      }
      curKeyword.value = '';
      search();
    }

    return {
      curSortType,
      curSortOption,
      sortOptions,
      isSupportSort,
      isSupportSearch,
      isSupportKeywordsTypeFilter,
      search,
      onBlur,
      onInput,
      onKeywordTypeChange,
      curKeyword,
      curKeywordType,
      searchOptions,
      filterAffiliateInput,
    };
  },
});
